import {Logger} from 'tslog';
import Api from '../api/BaseRequest';

export const LGDLogger = new Logger({
    name: 'VUE',
    hideLogPositionForProduction: true,
    prettyLogTemplate: "{{logLevelName}} {{name}} ",
    minLevel: process.env.NODE_ENV === 'production' ? 4 : 2, // 4: warn, 2: debug,
});

LGDLogger.attachTransport(logObj => {

    const message = logObj.error ? logObj.error.message : (logObj[0] ?? '');
    const stack = logObj.error ? logObj.error.stack : null;
    const info = logObj.error ? logObj.info : null;

    const payload = {
        name: logObj._meta.name,
        level: logObj._meta.logLevelName,
        message: message,
        stack: stack,
        info: info,
        location: window.location.href
    }

    try {
        if (window.errorCounter++ < window.errorMaxCount) {
            Api.Post('/ajax/vue/log', payload);
        }
    } catch (e) {/* empty */}
})


// handler for client side browser errors
window.errorCounter = 0;
window.errorMaxCount = 5;

window.addEventListener('error', function (errorEvent) {
    "use strict";

    let message = errorEvent.message;
    const col = errorEvent.colno;
    const line = errorEvent.lineno;
    const err = errorEvent.error;
    const source = errorEvent.filename;

    const dontLog = [
        'Error loading script',
        'Script error.',
        'Object required',
    ];

    let log = true;

    if (message) {
        for (let i = 0; i < dontLog.length; i++) {
            if (message.indexOf(dontLog[i]) > -1) {
                log = false;
                break;
            }
        }
    }


    if (log && (!source || source.startsWith(window.location.protocol + '//' + window.location.hostname))) {
        if (window.errorCounter++ < window.errorMaxCount) {
            // external extension/runtime noise filter
            if (errorFromExternalScript(message)) {
                return; // skip logging errors coming from external scripts/extensions
            }
            let errorObj = {
                "message": message,
                "url": document.location.href,
                "handled_by": "window.onerror",
                "file": source,
                "line": line + (col ? ":" + col : ""),
            };

            message += "\n" + JSON.stringify(errorObj, null, 4);

            if (err !== undefined) {
                message += "\nstack: " + err.stack;
            }

            Api.Post('/ajax/js/log', {"type": "client", "message": message});
        }
    }
});

function errorFromExternalScript(message) {
    if (!message) return false;
    // Only consider runtime error types that indicate missing/undefined references
    if (!/^(TypeError|ReferenceError)/.test(message)) return false;

    const lower = message.toLowerCase();
    const extensionTokens = ['__firefox__', 'window.ethereum', 'darkreader'];
    const missingIndicators = ['undefined', 'not an object', "can't find variable", 'is not defined'];

    const hasToken = extensionTokens.some(t => lower.indexOf(t) > -1);
    if (!hasToken) return false;

    const hasMissingIndicator = missingIndicators.some(ind => lower.indexOf(ind) > -1);
    if (!hasMissingIndicator) return false;

    return true; // external / irrelevant error, skip logging
}
